import AccessoryCommon from "./accessoryCommon";

export default class ShampooShelf extends AccessoryCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shampoo_shelf';
    this.partName = 'Shampoo Shelf';
    this.translateId = "visualizer.bathroom.accessories.shampoo_shelf";
    this.visible = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ShampooShelf());
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Accessories.ShampooShelf;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }

}
